import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_people",
  "use": "icon-icon_people-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_people\">\n<g opacity=\"0.8\">\n<ellipse cx=\"7.99972\" cy=\"5.91055\" rx=\"2.90389\" ry=\"2.91055\" stroke=\"white\" stroke-linecap=\"round\" />\n<path d=\"M13 12.9985C12.5698 10.6223 10.4949 8.82031 8 8.82031C5.50512 8.82031 3.43016 10.6223 3 12.9985\" stroke=\"white\" stroke-linecap=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol